import React from 'react';
import { FormattedMessage } from 'react-intl';
import messages from '../messages';

const BaggagePersonalEffectsShared = () => (
  <ol>
    <li>
    Airline Ticket Stub/Receipt.
    </li>
    <li>
    Baggage Claim Stub/Receipt.
    </li>
    <li>
    Police Report.
    </li>
    <li>
    Statement from Hotel/Motel, Airline Carrier or Airport Facility that concerns your lost property.
    Note: You must file a report with the appropriate authorities for damaged, lost or stolen property.
    </li>
    <li>
    Car Rental Agreement.
    </li>
    <li>
    Copies of reimbursement statements issued by an airline carrier, airport facility, car rental agency, travel agent,hotel/motel or other similar establishment or any other insurance company providing reimbursement to you for the loss.
    </li>
    <li>
    Proof of ownership of the items lost or stolen
    Note: Acceptable forms of proof of purchase include credit card statements, sales receipts or cancelled checks.
    </li>
  </ol>
);

export default BaggagePersonalEffectsShared;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.BaggagePersonalEffects/components/BaggagePersonalEffectsShared.js